/**
 * Bundled offline fallback, NOT the list of selectable languages: enablement is owned by
 * `list_languages.json` in the environment's language bucket. Add a locale here to ship a
 * bundled fallback for it; add it to the bucket catalog to offer it to users.
 */
export enum Language {
  en_US = 'en_US',
  de_DE = 'de_DE',
  fr_FR = 'fr_FR',
}
